var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-autocomplete", {
        attrs: {
          box: "",
          multiple: "",
          clearable: "",
          chips: "",
          "menu-props": { maxHeight: 450 },
          label: "Station Location",
          items: _vm.stationNames,
        },
        on: { change: _vm.handleUpdateFilters },
        model: {
          value: _vm.selectedLocations,
          callback: function ($$v) {
            _vm.selectedLocations = $$v
          },
          expression: "selectedLocations",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }